/**
 * Conditionally wraps children in a provided wrapper component.
 * @param condition - Boolean to determine if the wrapper should be applied.
 * @param wrapper - Function that takes children and returns a React element wrapping them.
 * @param children - The content to be conditionally wrapped.
 * @example
 * <ConditionalWrapper
 *   condition={isActive}
 *   wrapper={(children) => <div className="wrapper">{children}</div>}
 * >
 *   <span>Content</span>
 * </ConditionalWrapper>
 */

const ConditionalWrapper = ({ condition, wrapper, children }) => {
  if (typeof wrapper !== 'function') {
    console.warn('ConditionalWrapper: wrapper prop must be a function');
    return children;
  }
  return condition ? wrapper(children) : children;
}
export default ConditionalWrapper;
